import { IContent } from "@kunduz/data-access-cms-api";
import { FeatureWithSummaryItems } from "@kunduz/ui-components";
import React, { ReactElement } from "react";
import { getCmsIcon } from "../static/iconMappings";
import { trackEventNext } from "@kunduz/utility-analytics";

export const FeatureV2WithContext = (props: Props): ReactElement => {
  function onCtaClicked() {
    trackEventNext({
      event: "Feature Component Clicked",
      label: props.data.button.label,
      url: props.data.button.url,
    });
  }

  return (
    <FeatureWithSummaryItems
      sectionHeaderProps={{
        title: props.data.title,
        desc: props.data.description,
        badgeTheme: "student",
        align: "center",
        badgeText: props.data.badge,
        badgeIcon: getCmsIcon(props.data.badge_icon),
        size: "sm",
      }}
      theme={props.data.theme as any}
      ctaLabel={props.data.button.label}
      ctaUrl={props.data.button.url}
      summaryItems={props.data.items.map((x) => x.feature_summary.text)}
      imageUrl={props.data.image}
      onCtaClicked={onCtaClicked}
    />
  );
};

interface Props {
  data: IContent.FeatureV2ComponentData;
}
